import { render, staticRenderFns } from "./ApprovalHistoryModal.vue?vue&type=template&id=6192f140&scoped=true"
import script from "./ApprovalHistoryModal.vue?vue&type=script&lang=js"
export * from "./ApprovalHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./ApprovalHistoryModal.vue?vue&type=style&index=0&id=6192f140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6192f140",
  null
  
)

export default component.exports